import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { IMAGES } from "@/lib/constants";

export const PageBanner = ({ title, subtitle, image }) => (
  <section className="relative bg-navy">
    <img src={image || IMAGES.hero} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
    <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/85 to-navy/50" />
    <div className="relative max-w-7xl mx-auto px-6 py-16 lg:py-20">
      <nav className="flex items-center gap-1.5 text-xs text-slate-300 mb-3">
        <Link to="/" className="hover:text-gold">Home</Link>
        <ChevronRight className="h-3 w-3" />
        <span className="text-gold">{title}</span>
      </nav>
      <h1 className="font-head text-4xl sm:text-5xl font-black text-white">{title}</h1>
      {subtitle && <p className="mt-3 text-slate-200 max-w-2xl text-lg">{subtitle}</p>}
    </div>
  </section>
);
